import Collections from '@sorare/gameplay/src/components/collections/CollectionsPage';

import { NewUserDialog } from '@sorare/us-sports/src/components/collections/NewUserDialog';
import mlbCardsImg from '@sorare/us-sports/src/components/collections/NewUserDialog/assets/mlbCards.png';

import { ClubLayout } from '@sorare/manager/src/components/profile/ClubLayout';

const CollectionsPage = () => {
  return (
    <ClubLayout>
      <NewUserDialog img={mlbCardsImg} />
      <Collections />
    </ClubLayout>
  );
};

export default CollectionsPage;
